module.exports = __webpack_public_path__ + "imgs/gosPartnersLogo2.df1feb21.webp";